import { Button, FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { ReactComponent as EmptyStateIcon } from '@elementary/common-ui/assets/empty-state-dataset.svg';
import styled from 'styled-components';

const Wrapper = styled(FlexColumn)`
  padding: 24px;
  gap: 16px;
  align-items: center;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  width: 468px;
`;

type Props = {
  onForceLoad: () => void;
};

const GraphLimitMessage = ({ onForceLoad }: Props) => (
  <Wrapper>
    <EmptyStateIcon />
    <Typography sx={{ fontWeight: 500 }}>Large Lineage Dataset</Typography>
    <FlexColumn>
      <Typography sx={{ fontSize: 12 }}>
        The size of this lineage may affect browser performance.
      </Typography>
      <Typography sx={{ fontSize: 12 }}>
        We recommend filtering the dataset further before continuing.
      </Typography>
    </FlexColumn>
    <Button
      onClick={onForceLoad}
      sx={{ width: 'fit-content' }}
      variant="outlined"
    >
      Continue to view lineage
    </Button>
  </Wrapper>
);

export default GraphLimitMessage;
